import { render, staticRenderFns } from "./NoGender.vue?vue&type=template&id=7b9174b0&"
import script from "./NoGender.vue?vue&type=script&lang=js&"
export * from "./NoGender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports